export enum EPaymentItemType {
  HOURLY = "hourly",
  PER_UNIT = "per_unit",
  FLAT_FEE = "flat_fee",
  EXPENSE_REIMBURSEMENT = "expense_reimbursement",
  BONUS = "bonus",
}

export const rateBasedPaymentTypes = [
  EPaymentItemType.HOURLY,
  EPaymentItemType.PER_UNIT,
] as const;

export const fixedAmountPaymentTypes = [
  EPaymentItemType.FLAT_FEE,
  EPaymentItemType.BONUS,
  EPaymentItemType.EXPENSE_REIMBURSEMENT,
] as const;

export const isRateBasedPaymentType = (
  type: EPaymentItemType
): type is EPaymentItemType.HOURLY | EPaymentItemType.PER_UNIT =>
  (rateBasedPaymentTypes as readonly EPaymentItemType[]).includes(type);

export const isFixedAmountPaymentType = (
  type: EPaymentItemType
): type is
  | EPaymentItemType.FLAT_FEE
  | EPaymentItemType.BONUS
  | EPaymentItemType.EXPENSE_REIMBURSEMENT =>
  (fixedAmountPaymentTypes as readonly EPaymentItemType[]).includes(type);
